"use client";
import { useParams } from "next/navigation";

export function useLanguageFromUrl() {
  const params = useParams();
  return (params?.language as string) ?? "fi";
}
